/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../components.ts"/>


namespace DealerwareWebComponents {
    "use strict";


    export class SelectionBoxHelperService {

        public static $inject: string[] = [ '$compile', '$templateCache' ];

        constructor(
            public $compile         : ng.ICompileService,
            public $templateCache   : ng.ITemplateCacheService
        ) {

        }

        public create ( templateId      : string,
                        containerElement: ng.IAugmentedJQuery,
                        $containerScope : ng.IScope
        ) : ng.IAugmentedJQuery {

            var html = this.$templateCache.get(templateId);
            var elem = angular.element(html);

            (<any>elem.get(0)).uniqId = Math.round(Math.random() * Math.pow(10, 10));

            containerElement.append(this.$compile(elem)($containerScope));

            return elem;
        }

        public deleteBox  (
            boxElement: ng.IAugmentedJQuery
        ) : void {

            boxElement.parent().children().each((i: number, elem: any) => {

                if ((<any>boxElement).get(0).uniqId === elem.uniqId) {
                    angular.element(boxElement).remove();
                }
            });
        }

        // Goes and looks for the areaSelections directive to get needful properties from it.
        //
        public findSelectionManager ( currentElement: JQuery ) : any {

            var manager: any;

            while (currentElement[0].tagName.toLowerCase() !== 'body' && ! manager) {
                currentElement = currentElement.parent();
                if (currentElement && currentElement[0].tagName.toLowerCase() === 'area-selections') {
                    manager = currentElement;
                    break;
                }
            }

            return manager;
        }
    }

    getDealerwareWebComponentsModule().factory('SelectionBoxHelperService', (
        $compile        : ng.ICompileService,
        $templateCache  : ng.ITemplateCacheService
    ) => {
        return new SelectionBoxHelperService ($compile, $templateCache)
    });



    export class SelectionBoxDirectiveController {

        public static $inject: string[] = [
            '$scope', '$element', '$document', 'SelectionBoxHelperService'
        ];

        private eventParent         : any;
        private manager             : any;

        private box                 : any;

        private boxWatchers         : any = { };

        private targetDomSelector   : any;
        private onCreating          : any;
        private onSizing            : any;
        private onResizing          : any;
        private onMoving            : any;
        private onCreated           : any;
        private onSized             : any;
        private onResized           : any;
        private onMoved             : any;

        private resizeDisabled       : any;
        private moveDisabled         : any;

        constructor(
            private $scope   : any,
            private $element : any,
            private $document: any,
            private helper   : any
        ) {


            var that = this;

            // Selection box created, so bring it alive.
            //
            this.$scope.$watch( ( ) => {
                return that.box;
            }, ( box: any ) => {

                if (! box) {
                    return;
                }

                this.installBoxWatchers();
                this.installBoxMethods();
            });
        }

        // Box deleted, so get rid of all of its watchers.
        //
        private uninstallBoxWatchers () : void {

            var that = this;

            Object.keys(this.boxWatchers).forEach( ( scopeKey: string ) => {
                that.boxWatchers[scopeKey]();
                delete that.boxWatchers[scopeKey]
            });
        }

        private installBoxWatchers () : void {

            var that = this;

            [ 'createEvent', 'startX', 'startY', 'offsetX', 'offsetY', 'top', 'left', 'width', 'height',
              'selected', 'preselected', 'creating', 'created', 'sizing', 'sized', 'resizing', 'resized',
              'moving', 'moved'
            ]
                .forEach( ( scopeKey: string ) => {

                    that.boxWatchers[scopeKey] = that.$scope.$watch (
                        ( ) => {
                            return that.box[scopeKey];
                        },
                        ( scopeVal: any ) => {

                            if ( scopeKey === 'createEvent') {

                                if (scopeVal === undefined) {
                                    return;
                                }

                                // Loading a predefined box will have inserted these values into
                                // the eventObject.  This stuff will be blank if user input (a click)
                                // is creating the box.
                                //
                                if (! that.box.preDefined) {
                                    that.box.startX = scopeVal.offsetX;
                                    that.box.startY = scopeVal.offsetY;
                                    that.box.left   = scopeVal.offsetX;
                                    that.box.top    = scopeVal.offsetY;
                                }

                                // Gets the areaSelections directive.
                                //
                                that.manager = that.helper.findSelectionManager(that.$element);

                                // Check to see if there exists the DOM selector for the click container as
                                // an attribute on the SelectionBox itself, and if not, traverse to the
                                // areaSelections directive element itself and see if said attribute is there.
                                // If not, just use the areaSelections as the click-and-draw zone.
                                //
                                that.eventParent = angular.element(that.targetDomSelector);

                                if (! that.eventParent.get()[0]) {

                                    if (that.manager) {
                                        that.eventParent = angular.element(
                                            that.manager[0].attributes['target-dom-selector'].value
                                        );
                                    }
                                    else {
                                        that.eventParent = that.manager;
                                    }
                                }

                                // None of this can bet set up without an areaSelections, so if not given,
                                // install no event handlers which will result in no functionality.
                                //
                                if (that.eventParent[0]) {
                                    that.box.creating = true;
                                    that.onCreating();
                                    that.installEventHandlers();
                                }
                            }

                            // As with above, box starting coordinates are fed in or based on a user click.
                            //
                            else if ( scopeKey === 'offsetX' && ! isNaN(scopeVal)) {

                                that.box.left = Math.min(that.box.startX, scopeVal);

                                // Allow initialization of box height, but don't let it be sized beyond
                                // the bounds of the areaSelection.
                                //
                                var newWidth = Math.abs(that.box.offsetX - that.box.startX);
                                if ( that.box.width === undefined
                                    || newWidth <= that.manager.width() - that.box.offsetX + that.box.width
                                ) {
                                    that.box.width = newWidth;
                                }
                            }

                            // Ditto.
                            //
                            else if (scopeKey ==='offsetY' && ! isNaN(scopeVal)) {

                                that.box.top = Math.min(that.box.startY, scopeVal);

                                if (! that.box.preDefined) {

                                    // Allow initialization of box height, but don't let it be sized beyond
                                    // the bounds of the areaSelection.
                                    //
                                    var newHeight = Math.abs(that.box.offsetY - that.box.startY);
                                    if ( that.box.height === undefined
                                         || newHeight <= that.manager.height() - that.box.offsetY + that.box.height
                                       ) {
                                        that.box.height = newHeight;
                                    }
                                }
                            }

                            // There's movement all over the place!
                            //
                            // (box movement or resizing or creation dimensions definition
                            // caused by mouse movement)
                            //
                            else if ( ( scopeKey === 'top' || scopeKey ==='left'
                                        || scopeKey === 'height' || scopeKey ==='width'
                                      ) && ! isNaN(scopeVal)
                            ) {
                                that.$element.css(scopeKey, scopeVal);
                            }

                            // Set classes for selectionBox state events -- mouseover, clicked on, etc.
                            //
                            var mouseClasses  = [ 'creating', 'pre-selected', 'selected', 'moving', 'resizing' ];
                            var boxStateClass = that.getBoxStateClass();
                            if (boxStateClass && ! that.$element.hasClass(boxStateClass)) {
                                that.$element.removeClass(mouseClasses.join(' ')).addClass(boxStateClass);
                            }
                        });
                });
        }

        private installBoxMethods () : void {

            var that = this;

            this.box.delete = ( ) => {

                // Removes the actual DOM element.
                //
                that.helper.deleteBox(that.$element);

                // Blows away its event listeners.
                //
                that.$document.off('mouseup');
                that.eventParent.off('mousemove');
                that.eventParent.off('mouseover');
                //that.eventParent.off('mouseup');
                that.$element.off('mousemove');
                that.$element.off('mousedown');
                that.$element.off('mouseover');
                that.$element.off('mouseout');

                // Delete SelectionBox properties.
                //
                delete that.box.offsetX;
                delete that.box.offsetY;
                delete that.box.startX;
                delete that.box.startY;
                delete that.box.left;
                delete that.box.top;
                delete that.box.width;
                delete that.box.height;
                delete that.box.createEvent;
                delete that.box.createTimestamp;
                delete that.box.created;
                delete that.box.creating;
                delete that.box.element;
                delete that.box.delete;

                // Zero out box contents, if any.
                //
                if (that.box.content !== undefined) {
                    delete that.box.content.element;
                }

                // Get rid of property watchers.
                //
                that.uninstallBoxWatchers();
            }
        }

        private getBoxStateClass () : any {

            var className: string;

            if (this.box.creating) {
                className = 'creating';
            }
            // This presumes that the purpose of hovering and selecting is to move the box,
            // which might not always be true in the future.
            //
            else if (this.box.created && ! this.moveDisabled()) {
                if (this.box.selected) {
                    className = 'selected';
                }
                else if (this.box.preselected) {
                    className = 'pre-selected';
                }
            }

            return className;
        }

        private installEventHandlers () : void {

            var that = this;

            var boxPreselected = ( type?: string ) => {

                that.box.preselected = true;

                // Force scope update so ng-style works!  What a fucking genius I am!
                // Somebody please tell me there's a better way to do this!
                //
                that.$scope.$apply(function() {
                    that.$scope.foo = 'bar';
                });
            };

            var boxUnpreselected = ( type?: string ) => {

                if (! that.box.moving) {

                    that.$scope.$apply( ( ) => {
                        that.box.preselected = false;
                        that.$scope.foo = 'bar';
                    });
                }
            };

            var boxSelected = ( type?: string ) => {

                if (! that.box.moving) {

                    that.$scope.$apply( ( ) => {
                        that.box.selected = true;
                        that.box.sized = false;
                        that.box.resized = false;
                        that.box.moved = false;
                    });
                }
            };

            var boxUnselected = ( type?: string ) => {

                if (! that.box.moving) {
                    that.$scope.$apply( ( ) => {
                        that.box.selected = false;
                    });
                }
            };

            var boxSizing = ( offsetX: number, offsetY: number, type?: string ) => {

                that.box.sizing = true;

                that.$scope.$apply(function() {
                    that.box.offsetX = offsetX;
                    that.box.offsetY = offsetY;
                    that.onSizing();
                })
            };

            var boxResizing = ( offsetX: number, offsetY: number, type?: string ) => {

                if (that.resizeDisabled()) {
                    return;
                }

                that.box.resizing = true;

                that.$scope.$apply(function() {
                    that.box.offsetX = offsetX;
                    that.box.offsetY = offsetY;
                    that.onResizing();
                })
            };

            var boxMoving = ( x: number, y: number, type?: string ) => {

                if (that.moveDisabled()) {
                    return;
                }

                that.box.moving = true;

                that.$scope.$apply(function() {

                    var currentLeft = that.box.left;
                    var currentTop = that.box.top;
                    var maxX = that.manager.width()  - that.box.width;
                    var maxY = that.manager.height() - that.box.height;

                    that.box.left = x < 0 ? 0 : (x > maxX ? maxX : x);
                    that.box.top  = y < 0 ? 0 : (y > maxY ? maxY : y);

                    if (currentLeft !== x || currentTop !== y) {
                        that.onMoving();
                    }
                })
            };

            var boxPlacing = ( type?: string ) => {

                if (that.box.creating) {
                    that.box.creating = false;
                    that.box.created = true;
                    that.box.createTimestamp = Date.now();
                    that.onCreated();
                }

                if (that.box.sizing) {
                    that.box.sizing = false;
                    that.box.sized = true;
                    that.onSized();
                }

                if (that.box.resizing) {
                    that.box.resizing = false;
                    that.box.resized = true;
                    that.onResized();
                }

                if (that.box.moving) {
                    that.box.moving = false;
                    that.box.moved = true;
                    that.box.startX = that.box.left;
                    that.box.startY = that.box.top;
                    delete that.box.startMovingX;
                    delete that.box.startMovingY;
                    that.onMoved();
                }
            };

            // These events do a pretty good job of creating, sizing, and moving boxes correctly,
            // but refinements could be made so leave previous event settings behind as clues.
            //
            that.eventParent
                .on('mousemove', ( e: JQueryEventObject ) => {

                    if (that.box.creating) {
                        boxSizing(e.offsetX, e.offsetY, 'AREA');
                    }

                    if (that.box.moving) {
                        boxMoving(e.offsetX - that.box.startMovingX, e.offsetY - that.box.startMovingY, 'AREA');
                    }
                });

            that.$document
                .on('mouseup', ( e: JQueryEventObject) => {

                    boxPlacing('BOX');
                    if (that.box.selected) {
                        boxUnselected('BOX')
                    }

                    if (that.box.moving) {
                        that.box.moving = false;
                    }
                });

            that.$element
                .on('mousemove', ( e: JQueryEventObject ) => {

                    if (that.box.sizing) {
                        boxSizing(e.offsetX + that.box.startX, e.offsetY + that.box.startY, 'BOX');
                    }

                    if (that.box.resizing) {
                        boxResizing(e.offsetX + that.box.startX, e.offsetY + that.box.startY, 'BOX');
                    }

                    if (that.box.moving) {
                        boxMoving(that.box.left + e.offsetX - that.box.startMovingX, that.box.top + e.offsetY - that.box.startMovingY, 'BOX');
                    }
                })
                .on('mousedown', ( e: JQueryEventObject ) => {

                    boxSelected('BOX');

                    if (isNaN(that.box.startMovingX)) {
                        that.box.startMovingX = e.offsetX;
                        that.box.startMovingY = e.offsetY;
                    }
                    boxMoving(that.box.left + e.offsetX - that.box.startMovingX, that.box.top + e.offsetY - that.box.startMovingY, 'BOX');
                })
                .on('mouseover', ( e: JQueryEventObject ) => {
                    boxPreselected('BOX');
                })
                .on('mouseout', ( e: JQueryEventObject ) => {
                    boxUnpreselected('BOX');
                });
        }

        private $destroy () : void {
            this.uninstallBoxWatchers();
        }
    }

    getDealerwareWebComponentsModule().controller('SelectionBoxDirectiveController', SelectionBoxDirectiveController);



    export class SelectionBoxDirective implements ng.IDirective {

        public restrict         : string    =   'E';
        public controller       : any       =   'SelectionBoxDirectiveController';
        public controllerAs     : string    =   'SB';
        public bindToController : boolean   =   true;
        public require          : '^AS';
        public scope            : Object    =   {

            id                  : '=',
            box                 : '=?',

            onCreating          : '&',
            onCreated           : '&',
            onSizing            : '&',
            onSized             : '&',
            onResizing          : '&',
            onResized           : '&',
            onMoving            : '&',
            onMoved             : '&',

            onToolSelect        : '&?',
            onToolOver          : '&?',
            onToolOut           : '&?',
            onToolMove          : '&?',
            onToolRelease       : '&?',

            resizeDisabled      : '&?',
            moveDisabled        : '&?',

            targetDomSelector   : '@?',
        };
    }

    getDealerwareWebComponentsModule().directive('selectionBox', ( ) => new SelectionBoxDirective());


}
